import React from "react";

const StyledCard = ({ children, gradient = null, setMinHeight }) => {
    return(
        <div class="card" >
        <div class="container-card bg-yellow-box"
       style={{
        background: gradient || "linear-gradient(71deg, white, #f0f2f5, white)",
        minHeight: setMinHeight ? (window.innerWidth < 1100 ? "100%" : "286px") : undefined,
      }}
      
        >
          {children}
        </div>
      </div>
    )
}

export default StyledCard